import { colors } from 'app-v2/design-systems/theme/colors'
import { fonts } from 'app/common/typography/fonts'

export const COLOR = {
    PRIMARY: colors.bbqBrown,
    SECONDARY: colors.mayoEggWhite
}

export const BORDER = {
    RADIUS: {
        XXXL: '18px',
        XL: '14px',
        L: '12px',
        M: '10px',
        NONE: '0',
        S: '8px',
        XS: '4px'
    },
    WIDTH: {
        M: '4px',
        NONE: '0',
        S: '2px',
        XS: '1px'
    }
}

export const TEXT = {
    FONT_FAMILY: {
        DEFAULT: fonts.flameRegular,
        DEFAULT_SANS: fonts.flameSansRegular
    },
    FONT_SIZE: {
        XL: '24px',
        L: '20px',
        M: '16px',
        S: '12px'
    },
    LINE_HEIGHT: {
        M: '22px',
        S: '18px'
    }
}

export const SIZE = {
    XXS: 'Extra Extra Small',
    XS: 'Extra Small',
    S: 'Small',
    M: 'Medium',
    L: 'Large',
    XL: 'Extra Large',
    XXL: 'Extra Extra Large'
}

export const ORIENTATION = {
    VERTICAL: 'Vertical',
    HORIZONTAL: 'Horizontal'
}

export const SPACING = {
    XXXL: '36px',
    XXL: '32px',
    XL: '28px',
    L: '24px',
    M: '20px',
    S: '16px',
    XS: '12px',
    XXS: '8px',
    XXXS: '4px',
    NONE: '0'
}
